import { createContext } from 'react';

var IntlContext = /*#__PURE__*/createContext(undefined);

export { IntlContext as default };
//# sourceMappingURL=use-intl.esm7.js.map
